// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function Icons_Component$InfoCircle(props) {
  var height = props.height;
  var width = props.width;
  var width$1 = width !== undefined ? width : "20";
  var height$1 = height !== undefined ? height : "20";
  return React.createElement("svg", {
              className: props.className,
              height: height$1,
              width: width$1,
              fill: "none",
              viewBox: "0 0 20 20",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  d: "M10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0ZM10 18.5C5.313 18.5 1.5 14.687 1.5 10C1.5 5.313 5.313 1.5 10 1.5C14.687 1.5 18.5 5.313 18.5 10C18.5 14.687 14.687 18.5 10 18.5Z",
                  fill: "#317AAD"
                }), React.createElement("path", {
                  d: "M9.45 5.90945C9.52 5.97945 9.6 6.02945 9.689 6.06945C9.79 6.10945 9.879 6.11945 9.979 6.11945C10.08 6.11945 10.179 6.09945 10.269 6.06945C10.359 6.02945 10.439 5.96945 10.509 5.90945C10.579 5.83945 10.639 5.74945 10.669 5.65945C10.709 5.56945 10.729 5.46945 10.729 5.36945C10.729 5.27945 10.709 5.17945 10.669 5.08945C10.64 4.99945 10.58 4.90945 10.51 4.84945C10.44 4.77945 10.36 4.71945 10.27 4.67945C10.081 4.60945 9.88 4.60945 9.69 4.67945C9.6 4.71945 9.52 4.77945 9.45 4.84945C9.31 4.97945 9.229 5.17945 9.229 5.36945C9.229 5.46945 9.25 5.56945 9.29 5.65945C9.33 5.74945 9.38 5.83945 9.45 5.90945Z",
                  fill: "#317AAD"
                }), React.createElement("path", {
                  d: "M12.173 13.1441H10.975V8.53906C10.975 8.12506 10.639 7.78906 10.225 7.78906H8.76498C8.35098 7.78906 8.01498 8.12506 8.01498 8.53906C8.01498 8.95306 8.35098 9.28906 8.76498 9.28906H9.47498V13.1441H8.27698C7.86298 13.1441 7.52698 13.4801 7.52698 13.8941C7.52698 14.3081 7.86298 14.6441 8.27698 14.6441H12.173C12.587 14.6441 12.923 14.3081 12.923 13.8941C12.923 13.4801 12.587 13.1441 12.173 13.1441Z",
                  fill: "#317AAD"
                }));
}

var InfoCircle = {
  make: Icons_Component$InfoCircle
};

function Icons_Component$AttentionYellow(props) {
  var height = props.height;
  var width = props.width;
  var width$1 = width !== undefined ? width : "20";
  var height$1 = height !== undefined ? height : "20";
  return React.createElement("svg", {
              height: height$1,
              width: width$1,
              fill: "none",
              viewBox: "0 0 20 20",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("g", {
                  clipPath: "url(#clip0)"
                }, React.createElement("path", {
                      d: "M19.25 18.54H0.749995C0.617348 18.5417 0.486746 18.5072 0.372224 18.4403C0.257701 18.3733 0.163587 18.2764 0.0999949 18.16C0.0310851 18.0471 -0.00537109 17.9173 -0.00537109 17.785C-0.00537109 17.6527 0.0310851 17.523 0.0999949 17.41L9.35999 1.83002C9.43036 1.72483 9.52557 1.63861 9.6372 1.57898C9.74883 1.51935 9.87344 1.48816 10 1.48816C10.1266 1.48816 10.2512 1.51935 10.3628 1.57898C10.4744 1.63861 10.5696 1.72483 10.64 1.83002L19.89 17.41C19.9589 17.523 19.9954 17.6527 19.9954 17.785C19.9954 17.9173 19.9589 18.0471 19.89 18.16C19.8272 18.2749 19.7347 18.3709 19.6221 18.4377C19.5095 18.5046 19.3809 18.5399 19.25 18.54ZM2.06999 17H17.93L10 3.68002L2.06999 17Z",
                      fill: "#F0B02D"
                    }), React.createElement("path", {
                      d: "M10 12.88C9.80109 12.88 9.61032 12.801 9.46967 12.6603C9.32902 12.5197 9.25 12.3289 9.25 12.13V8.04999C9.25 7.85108 9.32902 7.66031 9.46967 7.51966C9.61032 7.37901 9.80109 7.29999 10 7.29999C10.1989 7.29999 10.3897 7.37901 10.5303 7.51966C10.671 7.66031 10.75 7.85108 10.75 8.04999V12.13C10.75 12.3289 10.671 12.5197 10.5303 12.6603C10.3897 12.801 10.1989 12.88 10 12.88Z",
                      fill: "#F0B02D"
                    }), React.createElement("path", {
                      d: "M10 15.62C9.90023 15.6203 9.80147 15.5999 9.71001 15.56C9.62075 15.522 9.53936 15.4678 9.47001 15.4C9.39658 15.3314 9.34156 15.2454 9.31001 15.15C9.27006 15.0621 9.24959 14.9666 9.25001 14.87C9.2497 14.7702 9.27013 14.6715 9.31001 14.58C9.3851 14.3989 9.52896 14.2551 9.71001 14.18C9.82178 14.1404 9.94133 14.1279 10.0589 14.1435C10.1764 14.1591 10.2886 14.2024 10.3861 14.2697C10.4837 14.337 10.564 14.4266 10.6203 14.5309C10.6766 14.6352 10.7073 14.7515 10.71 14.87C10.7077 15.0684 10.6289 15.2583 10.49 15.4C10.3594 15.5313 10.1849 15.6097 10 15.62Z",
                      fill: "#F0B02D"
                    })), React.createElement("defs", undefined, React.createElement("clipPath", {
                      id: "clip0"
                    }, React.createElement("rect", {
                          height: "20",
                          width: "20",
                          fill: "white"
                        }))));
}

var AttentionYellow = {
  make: Icons_Component$AttentionYellow
};

export {
  InfoCircle ,
  AttentionYellow ,
}
/* react Not a pure module */
